import cartoonMusic2 from './cartoon_2_music.mp3';
import cartoonMusic3 from './cartoon_3_music.mp3';
import cartoonMusic4 from './cartoon_4_music.mp3';
import cartoonMusic5 from './cartoon_5_music.mp3';
import cartoonMusic6 from './cartoon_6_music.mp3';
import cartoonMusic1 from './cartoon_music.mp3';
import characterDay from './character_day.mp3';
import characterNight from './character_night.mp3';
import clickButton from './click_button.mp3';
import closedPad from './closed_pad.mp3';
import clothesShopMusic from './clothes_shop_music.mp3';
import coldCola from './cold_cola.mp3';
import createCharacter from './create_character.mp3';
import dailyQuestComplited from './daily_quest_complited.mp3';
import donateEffect from './donate_effect.mp3';
import electricMusic from './el.mp3';
import electricFinish from './el_finish.mp3';
import electricLoss from './el_lose.mp3';
import error2 from './error_2.mp3';
import error3 from './error_3.mp3';
import finalQuest from './final_quest.mp3';
import fishFind from './fish_find.mp3';
import fishing1 from './fishing_1.mp3';
import funnySound from './funny_sound.mp3';
import funnySound2 from './funny_sound_2.mp3';
import headlightsToggle from './headlights_toggle.mp3';
import linkCursor from './link_cursor.mp3';
import linkCursor2 from './link_cursor_2.mp3';
import lockPad from './lock_pad.mp3';
import lowReward from './low_reward.mp3';
import mine1 from './mine.mp3';
import mine2 from './mine2.mp3';
import mine3 from './mine3.mp3';
import notification from './notification.mp3';
import openInventory from './open_inventory.mp3';
import openPad from './open_pad.mp3';
import random4Sound from './random_4_sound.mp3';
import seatbeltFasten from './seatbelt_fasten.mp3';
import seatbeltUnfasten from './seatbelt_unfasten.mp3';
import startFishing from './start_fishing.mp3';
import superReward from './super_rewards.mp3';
import trashLootSound from './trash_loot_sound.mp3';
import tuningSet from './tuning_set.mp3';
import unlockPad from './unlock_pad.mp3';
import upLevel3 from './up_level_3.mp3';

export enum Sound {
	LinkCursor = 'link_cursor',
	LinkCursor2 = 'link_cursor_2',
	ClosedPad = 'closed_pad',
	ClothesShopMusic = 'clothes_shop_music',
	ColdCola = 'cold_cola',
	DailyQuestComplited = 'daily_quest_complete',
	DonateEffect = 'donate_effect',
	FinalQuest = 'final_quest',
	Fishing1 = 'fishing_1',
	FunnySound = 'funny_sound',
	FunnySound2 = 'funny_sound_2',
	HeadlightsToggle = 'headlights_toggle',
	Notification = 'notification',
	OpenPad = 'open_pad',
	Random4Sound = 'random_4_sound',
	TrashLootSound = 'trash_loot_sound',
	TuningSet = 'tuning_set',
	UpLevel3 = 'up_level_3',
	LowReward = 'low_reward',
	SuperReward = 'super_reward',
	CartoonMusic1 = 'cartoon_music_1',
	CartoonMusic2 = 'cartoon_music_2',
	CartoonMusic3 = 'cartoon_music_3',
	CartoonMusic4 = 'cartoon_music_4',
	CartoonMusic5 = 'cartoon_music_5',
	CartoonMusic6 = 'cartoon_music_6',
	ElectricMusic = 'electric_music',
	ElectricFinish = 'electric_finish',
	ElectricLoss = 'electric_loss',
	Mine1 = 'mine_1',
	Mine2 = 'mine_2',
	Mine3 = 'mine_3',
	Error2 = 'error_2',
	Error3 = 'error_3',
	CreateCharacter = 'create_character',
	CharacterDay = 'character_day',
	CharacterNight = 'character_night',
	LockPad = 'lock_pad',
	UnlockPad = 'unlock_pad',
	OpenInventory = 'open_inventory',
	StartFishing = 'start_fishing',
	FishFind = 'fish_find',
	ClickButton = 'click_button',
	SeatbeltFasten = 'seatbelt_fasten',
	SeatbeltUnfasten = 'seatbelt_unfasten',
}

export const sounds: Record<Sound, string> = {
	[Sound.LinkCursor]: linkCursor,
	[Sound.LinkCursor2]: linkCursor2,
	[Sound.ClosedPad]: closedPad,
	[Sound.ClothesShopMusic]: clothesShopMusic,
	[Sound.ColdCola]: coldCola,
	[Sound.DailyQuestComplited]: dailyQuestComplited,
	[Sound.DonateEffect]: donateEffect,
	[Sound.FinalQuest]: finalQuest,
	[Sound.Fishing1]: fishing1,
	[Sound.FunnySound]: funnySound,
	[Sound.FunnySound2]: funnySound2,
	[Sound.HeadlightsToggle]: headlightsToggle,
	[Sound.Notification]: notification,
	[Sound.OpenPad]: openPad,
	[Sound.Random4Sound]: random4Sound,
	[Sound.TrashLootSound]: trashLootSound,
	[Sound.TuningSet]: tuningSet,
	[Sound.UpLevel3]: upLevel3,
	[Sound.LowReward]: lowReward,
	[Sound.SuperReward]: superReward,
	[Sound.CartoonMusic1]: cartoonMusic1,
	[Sound.CartoonMusic2]: cartoonMusic2,
	[Sound.CartoonMusic3]: cartoonMusic3,
	[Sound.CartoonMusic4]: cartoonMusic4,
	[Sound.CartoonMusic5]: cartoonMusic5,
	[Sound.CartoonMusic6]: cartoonMusic6,
	[Sound.ElectricMusic]: electricMusic,
	[Sound.ElectricFinish]: electricFinish,
	[Sound.ElectricLoss]: electricLoss,
	[Sound.Mine1]: mine1,
	[Sound.Mine2]: mine2,
	[Sound.Mine3]: mine3,
	[Sound.Error2]: error2,
	[Sound.Error3]: error3,
	[Sound.CreateCharacter]: createCharacter,
	[Sound.CharacterDay]: characterDay,
	[Sound.CharacterNight]: characterNight,
	[Sound.LockPad]: lockPad,
	[Sound.UnlockPad]: unlockPad,
	[Sound.OpenInventory]: openInventory,
	[Sound.StartFishing]: startFishing,
	[Sound.FishFind]: fishFind,
	[Sound.ClickButton]: clickButton,
	[Sound.SeatbeltFasten]: seatbeltFasten,
	[Sound.SeatbeltUnfasten]: seatbeltUnfasten,
};

const defaultVolumes: Partial<Record<Sound, number>> = {
	[Sound.LinkCursor]: 0.3,
	[Sound.CharacterDay]: 0.5,
	[Sound.CharacterNight]: 0.5,
	[Sound.CreateCharacter]: 0.2,
	[Sound.Notification]: 0.5,
	[Sound.Error3]: 0.5,
	[Sound.ElectricFinish]: 0.5,
	[Sound.ElectricLoss]: 0.5,
	[Sound.ClickButton]: 0.3,
	[Sound.DailyQuestComplited]: 0.5,
	[Sound.FunnySound]: 0.5,
	[Sound.FunnySound2]: 0.5,
	[Sound.HeadlightsToggle]: 0.5,
	[Sound.OpenInventory]: 0.5,
};

const audioCache: Partial<Record<Sound, HTMLAudioElement>> = {};

let globalVolume = 1;

const loopingAudios = new Set<HTMLAudioElement>();
let isMuted = false;

export const applyMuted = (value: boolean) => {
	isMuted = value;
	for (const audio of loopingAudios) {
		if (value) {
			audio.pause();
		} else {
			audio.play().catch((err) => {
				console.warn('Playback failed:', err);
			});
		}
	}
};

export const preloadSound = (sound: Sound) => {
	const src = sounds[sound];

	if (!src) {
		console.warn(`Sound not found: ${sound}`);
		return;
	}

	if (!audioCache[sound]) {
		const audio = new Audio(src);
		audio.preload = 'auto';
		audio.load();
		audioCache[sound] = audio;
	}
};

export const preloadAllSounds = () => {
	Object.values(Sound).forEach((sound) => {
		preloadSound(sound);
	});
};

export const preloadCommonSounds = () => {
	const commonSounds = [
		Sound.LockPad,
		Sound.UnlockPad,
		Sound.OpenPad,
		Sound.ClosedPad,
		Sound.Notification,
		Sound.LinkCursor,
		Sound.OpenInventory,
		Sound.SeatbeltFasten,
		Sound.SeatbeltUnfasten,
	];

	commonSounds.forEach((sound) => {
		preloadSound(sound);
	});
};

export const setSoundVolume = (volume: number) => {
	globalVolume = Math.max(0, Math.min(volume, 1));
	for (const audio of Object.values(audioCache)) {
		if (audio) {
			audio.volume = globalVolume;
		}
	}
};

export const getSoundVolume = () => {
	return globalVolume;
};

export const playSound = (sound: Sound, volume = 1) => {
	const src = sounds[sound];

	if (!src) {
		console.warn(`Sound not found: ${sound}`);
		return;
	}

	if (!audioCache[sound]) {
		const audio = new Audio(src);
		audioCache[sound] = audio;
	}

	const audio = audioCache[sound]!;
	audio.pause();
	audio.currentTime = 0;

	const soundVolume = defaultVolumes?.[sound] ?? volume;

	audio.volume = Math.max(0, Math.min(volume * globalVolume * soundVolume, 1));

	audio.play().catch((err) => {
		console.warn('Playback failed:', err);
	});
};

export const stopSound = (sound: Sound) => {
	const audio = audioCache[sound];
	if (audio) {
		audio.pause();
		audio.currentTime = 0;
	}
};

export const playSoundLoop = (sound: Sound, volume = 1) => {
	const src = sounds[sound];

	if (!src) {
		console.warn(`Sound not found: ${sound}`);
		return () => {};
	}

	const audio = new Audio(src);
	const soundVolume = defaultVolumes?.[sound] ?? volume;
	audio.volume = Math.max(0, Math.min(volume * globalVolume * soundVolume, 1));
	audio.loop = true;

	loopingAudios.add(audio);

	if (!isMuted) {
		audio.play().catch((err) => {
			console.warn('Playback failed:', err);
		});
	}

	return () => {
		loopingAudios.delete(audio);
		audio.pause();
		audio.currentTime = 0;
		audio.loop = false;
	};
};
